import { root } from './peak-concurrent-viewers';

export const peakConcurrentViewers = {
  ...root,
};
